import ServerConstraintsHandler from './server-constraints-handler';
import BrowserConstraintsHandler from './browser-constraints-handler';
import ConstraintsHandler from './constraints-handler';

export default class ConstraintsHandlerFactory {
    private readonly state;
    constructor(state) {
        this.state = state;
    }

    public initHandler(): ConstraintsHandler {
        return this.isGenerationOnServerSide() ? this.initServerHandler() : this.initBrowserHandler();
    }

    private isGenerationOnServerSide(): boolean {
        const {lineupGenerator, sportConfig} = this.state;
        const {settings} = lineupGenerator;

        return settings.isBackendGeneratorType(sportConfig);
    }

    private initBrowserHandler(): ConstraintsHandler {
        const args = this.getCommonHandlerArguments();
        // @ts-ignore
        args.executable.beforeReturningConstraints = function (operationData) {
            const {
                constraints: {afterCreating: constraints},
            } = operationData;
            const {objective, subjectTo} = constraints;
            // console.log("objective\n", objective);
            // Object.keys(subjectTo).map(key => console.log(`${key}\n`, subjectTo[key]));
            let str = '';
            str += 'max\n' + objective + '\n';
            str += 'st\n' + Object.values(subjectTo).join('\n') + '\n';
            str += 'bound\n' + constraints.bound + '\n';
            str += 'gen\n' + constraints.general + '\n';
            // console.log("finalConstraints\n", str);
            return str;
        };

        return new BrowserConstraintsHandler(args);
    }

    private initServerHandler(): ConstraintsHandler {
        const args = this.getCommonHandlerArguments();
        // @ts-ignore
        args.executable.beforeReturningConstraints = function (operationData) {
            const {
                constraints: {afterCreating: constraints},
            } = operationData;
            // console.log('incomingConstraints', {...constraints});
            let subjectTo: object[] = [];
            Object.values(constraints.subjectTo).map((item) => {
                // @ts-ignore
                subjectTo = [...subjectTo, ...item];
            });

            let objective = {
                row: {
                    ...constraints.objective.row,
                    ...constraints.randomObjective.row,
                    ...constraints.additionalObjective.row,
                },
            };

            const obj = {
                obj: objective,
                constraints: [...subjectTo],
            };
            // console.log('finalConstraints', {...obj});
            return {...obj};
        };

        return new ServerConstraintsHandler(args);
    }

    private getCommonHandlerArguments(): object {
        return {
            state: this.state,
            executable: {
                areConstraintsChangeable(operationData, settings) {
                    if (settings.prioritizeCompletingLineupsAboveExp) {
                        const {
                            afterCreating: {subjectTo},
                        } = operationData.constraints;

                        return (
                            (subjectTo.hasOwnProperty('exposureMax') && subjectTo.exposureMax.length) ||
                            (subjectTo.hasOwnProperty('exposureMin') && subjectTo.exposureMin.length)
                        );
                    }

                    return false;
                },
            },
        };
    }
}
